/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface HandleReplyOut {
  reply_id: string;
  handled_action: string;
  handled_at: string;
  consent_record_id: string | null;
  cut_request_id: string | null;
}
